import { Dispatch, SetStateAction, useState } from 'react';
import { DayPickerSingleProps } from 'react-day-picker';
import { useTranslation } from 'react-i18next';
import { format, isToday } from 'date-fns';
import { CalendarIcon, CaretDownIcon, CheckIcon } from '@zep/icons';
import { Button } from '@zep/ui';
import { DatePicker } from '@zep/ui/experimental';
import { cn } from '@zep/utils';
type PlanPaymentDatePickerProps = {
  className?: string;
  calendarProps?: Partial<Omit<DayPickerSingleProps, 'mode'>>;
  selected: Date | undefined;
  onSelect: Dispatch<SetStateAction<Date | undefined>>;
  disabled?: boolean;
};
export const PlanPaymentDatePicker = (props: PlanPaymentDatePickerProps) => {
  const {
    className,
    onSelect,
    disabled = false,
    selected,
    calendarProps
  } = props;
  const [isCalendarPopoverOpen, setIsCalendarPopoverOpen] = useState(false);
  const {
    t
  } = useTranslation(['subscription']);
  return <>
      {disabled ? <div className="flex h-[34px] w-full cursor-not-allowed items-center justify-between rounded-[8px] border border-gray-300 bg-gray-100 px-[8px] py-[5px] opacity-50">
          <div className="flex items-center gap-[8px]">
            <CalendarIcon width={16} height={16} />
            <span>{format(selected || new Date(), 'yyyy. MM. dd')}</span>
          </div>
          <CaretDownIcon width={13} height={13} />
        </div> : <DatePicker selected={selected} isPopoverOpen={isCalendarPopoverOpen} onPopOverOpenChange={setIsCalendarPopoverOpen} onSelect={value => {
      onSelect(value);
      setIsCalendarPopoverOpen(false);
    }} calendarProps={{
      ...calendarProps,
      numberOfMonths: 2,
      required: true,
      disabled: {
        before: new Date()
      }
    }} className="size-full cursor-pointer" contentClassName="w-full rounded-[12px] overflow-hidden shadow-[0px_8px_16px_2px_rgba(42, 39, 65, 0.18)]" popoverAlign="center" footer={<div className="flex w-full justify-end px-[10.5px] pb-[10.5px]">
              <Button leftSlot={<CheckIcon width={14} height={14} />} variant="sub" size="xs" onClick={() => {
        onSelect(new Date());
        setIsCalendarPopoverOpen(false);
      }}>
                {t('subscription:payment.calendar.fromToday', {
          defaultValue: '오늘부터 시작할래요'
        })}
              </Button>
            </div>}>
          <div className={cn('flex items-center justify-between border border-gray-300 rounded-[8px] px-[8px] py-[5px] h-[34px]', className)}>
            <div className="flex items-center gap-[8px]">
              <CalendarIcon width={16} height={16} />
              <span>
                {selected ? `${format(selected, 'yyyy. MM. dd')}${isToday(selected) ? ` (${t('subscription:payment.calendar.today', {
              defaultValue: '오늘'
            })})` : ''}` : '시작일을 선택해주세요.'}
              </span>
            </div>
            <CaretDownIcon width={13} height={13} />
          </div>
        </DatePicker>}
    </>;
};